import { IconContext } from "react-icons/lib";
import { IoMdThumbsUp } from "react-icons/io";
import header from "../../../assets/header.jpg";

export default function Galloria({postImg}) {
    // console.log(postImg);
  return (
        <div className="item">
            <img className="gallery-item__img" src={header} alt="" />
            <div className="gallery__item-likes--icons">
                <IconContext.Provider value={{ className: "gili-icon like" }}>
                    <IoMdThumbsUp />
                </IconContext.Provider>
            </div>
        </div>
  );
}
